import { ActionReducerMap } from '@ngrx/store';
import { State } from './state';
import { sellerReducer } from './seller';

export const reducers: ActionReducerMap<State> = {
  seller: sellerReducer
};
